var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6de938f10e00499dcb49a03417742b4fe3491e6d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dashboard-ui@emptor"]={id:"6de938f10e00499dcb49a03417742b4fe3491e6d"};
      